<template>

  <div class='modules'>
    <div class='margin' v-if="list && list.length>0">

      <a v-if="list.length===1" v-for="(item,index) in list"
         href='javascript:'
         class="modules-item single"
         :class="item.type"
         @click="navigateToDetail(item)"
      >
        <p class='title'>{{item.title}}</p>
        <p class='text'>{{item.text}}</p>
        <img v-if="item.icon" class='icon' :src="item.icon" alt=""/>
      </a>


      <div class='double-wrap' v-if="list.length === 2">
        <a v-for="(item,index) in list"
           class="modules-item double"
           :class="item.type"
           @click="navigateToDetail(item)"

        >
          <p class='title'>{{item.title}}</p>
          <p class='text'>{{item.text}}</p>

          <img v-if="item.icon" class='icon' :src="item.icon" alt=""/>

        </a>
      </div>


      <div class='triple-wrap clearfix' v-if="list.length === 3">
        <a v-for="(item,index) in list"
           href='javascript:'
           class="modules-item triple"
           :class="item.type"
           @click="navigateToDetail(item)"
        >
          <p class='title'>{{item.title}}</p>
          <p class='text'>{{item.text}}</p>

          <img v-if="item.icon" class='icon' :src="item.icon" alt=""/>
        </a>
      </div>


      <div class='four-wrap' v-if="list.length === 4">
        <a v-for="(item,index) in list"
           href='javascript:'
           class="modules-item four"
           :class="item.type"
           @click="navigateToDetail(item)"

        >
          <p class='title'>{{item.title}}</p>
          <p class='text'>{{item.text}}</p>

          <img v-if="item.icon" class='icon' :src="item.icon" alt=""/>

        </a>

      </div>

    </div>

  </div>

</template>


<script>
// 首页优惠券专区 / 拼团学车 / 抽奖专区 / 红包专区
export default {
  name: 'modules',
  props: {
    navList: null,
  },
  data() {
    return {
      list: [
        {type: 'ticket', title: '优惠券专区', text: '立即抢购', icon: 'youhuiquan-kuai'},
        {type: 'car', title: '拼团学车', text: '立即抢购', icon: 'car-kuai'},
        {type: 'gift', title: '抽奖专区', text: '立即抢购', icon: 'hongbao-kuai'},
        {type: 'packet', title: '红包专区', text: '立即抢购', icon: 'liwu-kuai'},
      ],
    }
  },
  created() {
    var type = '';
    var title = '';
    var icon = '';
    var path = '';
    var slogan = '';
    var link_type = '';
    if (this.navList && this.navList.length > 0) {
      this.list = [];
      this.navList.forEach((element, index) => {
        if (index === 0) {
          type = 'ticket';
          icon = 'youhuiquan-kuai';
        } else if (index === 1) {
          type = 'car';
          icon = 'car-kuai';
        } else if (index === 2) {
          type = 'gift';
          icon = 'hongbao-kuai';
        } else {
          type = 'packet';
          icon = 'liwu-kuai';
        }
        title = element.menu_name;
        slogan = element.slogan;
        icon = element.menu_img ? element.menu_img : require(`../assets/images/${icon}.png`);
        path = element.menu_link_detail;
        link_type = element.link_type;
        this.list.push({type: type, title: title, text: slogan, icon: icon, path: path,link_type:link_type});
      });
    }
  },
  methods: {
    navigateToDetail(item) {
      let path;
      // switch(item.type) {
      // 	case 'ticket':
      // 		path = '/CouponSection';
      // 	break;
      // 	case 'car':
      // 		path = '/pintuan';
      // 	break;
      // 	case 'gift':
      // 		path = '/luckydraw';
      // 	break;
      // 	case 'packet':
      // 		path = '';
      // 	break;
      // 	default:
      // 	path = ''
      // 	break;
      //}
      console.log(item)
      path = item.path;
      var host = window.location.host;
      if(path.indexOf("maintain") != -1){
            window.location.href = 'http://'+host+'/'+path+'/#/';
        }else if(path.indexOf("businessList") != -1){
            window.location.href = 'http://'+host+'/maintain/#/pages/store-list/store-list?project_id=0';
        }else{
          if(item.link_type == 2){
              if(item.menu_link_detail !== null && item.menu_link_detail !== 'null'){
                window.location.href=path
              }
          }else{
            path && this.$router.push({path})
          }
          
        }
      
    }
  },
}
</script>
<style lang="less" scoped>
.modules {
  .margin {
    margin: 0 14px 0 14px;
  }

  // 个数为2时
  .double-wrap,
  .four-wrap {
    display: flex;
  }

  .four-wrap {
    flex-wrap: wrap;
  }

  &-item {
    position: relative;
    box-sizing: border-box;
    display: block;
    color: #fff;
    border-radius: 5px;
    .title {
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 10px;
    }

    .text {
      font-size: 15px;
      font-weight: 400;
    }

    .icon {
      position: absolute;
    }
  }

  &-item.single {
    width: 100%;
    height: 100px;
    border-radius: 3px;
    padding: 20px 30px;

    .icon {
      right: 30px;
      bottom: 0;
    }
  }

  &-item.double {
    flex-basis: 50%;
    padding: 15px;
    height: 90px;

    &:first-child {
      margin-right: 5px;
    }

    .icon {
      width: 55px;
      height: 55px;
      right: 7px;
      bottom: 0;
    }
  }

  &-item.triple {
    &:first-child {
      float: left;
      width: ~'calc(50% - 2.5px)';
      height: 185px;
      padding: 15px 20px;
      margin-right: 5px;
      overflow: hidden;

      .icon {
        width: 170px;
        top: 80px;
        left: 50px;
      }
    }

    &:not(:first-child) {
      float: left;
      width: ~'calc(50% - 2.5px)';
      height: 90px;
      padding: 15px;
      .icon {
        width: 55px;
        height: 55px;
      }
    }

    &:nth-child(2) {
      float: left;
      width: ~'calc(50% - 2.5px)';
      height: 90px;
      margin-bottom: 5px;
    }

    .icon {
      bottom: 5px;
      right: 10px;
    }
  }

  &-item.four {
    flex-basis: ~'calc(50% - 2.5px)';
    padding: 15px;

    &:nth-child(1),
    &:nth-child(2) {
      margin-bottom: 5px;
    }

    &:nth-child(odd) {
      margin-right: 5px;
    }

    .icon {
      bottom: 0;
      right: 7px;
      width: 55px;
      height: 55px;
    }
  }

  &-item.ticket {
    background: linear-gradient(208deg,
    rgba(232, 140, 228, 1) 0%,
    rgba(132, 99, 253, 1) 100%);
  }

  &-item.car {
    background: linear-gradient(208deg,
    rgba(255, 155, 189, 1) 0%,
    rgba(255, 103, 155, 1) 100%);
  }

  &-item.gift {
    background: linear-gradient(208deg,
    rgba(160, 244, 233, 1) 0%,
    rgba(35, 185, 190, 1) 100%);
  }

  &-item.packet {
    background: linear-gradient(208deg,
    rgba(255, 176, 91, 1) 0%,
    rgba(252, 100, 67, 1) 100%);
  }
}
</style>
